function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9zdWNjZXNzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9zdWNjZXNzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBTdWNjZXNzKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgYXJpYS1sYWJlbD1cIlN1Y2Nlc3NcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE2IDZjNS41MjIgMCAxMCA0LjQ3NyAxMCAxMCAwIDUuNTIyLTQuNDc4IDEwLTEwIDEwUzYgMjEuNTIyIDYgMTZjMC01LjUyMyA0LjQ3OC0xMCAxMC0xMHptMCAyYy00LjQxMSAwLTggMy41ODktOCA4czMuNTg5IDggOCA4IDgtMy41ODkgOC04LTMuNTg5LTgtOC04em00LjY3NCAzLjg5YS45MTUuOTE1IDAgMDEuMDkgMS4zMTRMMTQuMzMgMjAuMzRhLjk2OS45NjkgMCAwMS0xLjQ0NC0uMDA5bC0xLjY1OC0yLjAzYS45MTcuOTE3IDAgMDEuMTA3LTEuMzE0Ljk3Ljk3IDAgMDExLjM0NC4xMDVsLjk0MiAxLjIwOSA1LjcwOC02LjMyNGEuOTY4Ljk2OCAwIDAxMS4zNDUtLjA4OHpcIlxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgICBmaWxsPXtwcmltYXJ5Q29sb3J9XG4gICAgICAvPlxuICAgIDwvc3ZnPlxuICApO1xufVxuXG5TdWNjZXNzLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgU3VjY2VzcztcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Success(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "aria-label": "Success",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M16 6c5.522 0 10 4.477 10 10 0 5.522-4.478 10-10 10S6 21.522 6 16c0-5.523 4.478-10 10-10zm0 2c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm4.674 3.89a.915.915 0 01.09 1.314L14.33 20.34a.969.969 0 01-1.444-.009l-1.658-2.03a.917.917 0 01.107-1.314.97.97 0 011.344.105l.942 1.209 5.708-6.324a.968.968 0 011.345-.088z",
    fillRule: "evenodd",
    fill: primaryColor
  }));
}

Success.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Success;